import { Autocomplete, Button, Checkbox, FormControl, FormControlLabel, FormGroup,InputLabel,MenuItem,Select, TextField, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import axios from 'axios';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { Stack } from '@mui/system';
import { Image } from 'cloudinary-react'
import { useAddSmartphoneMutation, useGetAllBrandsQuery, useGetAllGroupsQuery, useGetAllColorsQuery, useGetAllStoragesQuery, useAddGroupMutation, useGetAllModelsQuery } from '../../../../features/fullApi'
import { useTheme } from '@mui/material/styles';
import { toast } from 'react-hot-toast';
import ClearIcon from '@mui/icons-material/Clear';

const CreateProduct = ({getProducts}) => { 
  
  window.scrollTo(0,0)
  const [selectedFile, setSelectedFile] = useState([]);
  const [brand, setBrand] = useState("");

  const [color, setColor] = useState("");
  const [group, setGroup] = useState("");
  const [model, setModel] = useState("");

  const {data: brands, error: brandsError, isLoading: isLoadingBrands} = useGetAllBrandsQuery()
  const {data: storages, error: storagesError, isLoading: isLoadingStorages} = useGetAllStoragesQuery()
  const {data: colors, error: colorsError, isLoading: isLoadingColors} = useGetAllColorsQuery()
  const {data: groups, error: groupsError, isLoading: isLoadingGroups} = useGetAllGroupsQuery()
  const {data: models, error: modelsError, isLoading: isLoadingModels} = useGetAllModelsQuery()

  useEffect(() => {
    values.brands = brands
  }, [brands])

  useEffect(() => {
    values.storages = storages
  }, [storages])

  useEffect(() => {
    values.colors = colors
  }, [colors])

  useEffect(() => {
    values.groups = groups
  }, [groups])

  useEffect(() => {
    values.models = models
  }, [models])


  const [selectedStorages, setSelectedStorages] = useState([])

  const handleBrand = (event) => {
    console.log("event on brand", event.target)
    setBrand(event.target.value);
  };

  const handleColor = (event) => {
    console.log("event.target", event.target)
    setColor(event.target.value);
  };

  const handleModel = (event) => {
    setModel(event.target.value);
  };
  
  const user = JSON.parse(localStorage.getItem('user'))

  const [productImgLink, setProductImgLink] = useState("")
  const [showBtn, setShowBtn] = useState(false)

  const uploadImage = async () => {
    const formData = new FormData()
    formData.append("file", selectedFile)
    formData.append("upload_preset", "zt8iigue")
    const data = await axios.post("https://api.cloudinary.com/v1_1/deqqgmfxk/image/upload", formData)
    .then(res => {
      setProductImgLink(res.data.secure_url)
      setShowBtn(true)
    })
  };

  const [optionz, setOptionz] = useState([])
  
  const [ran, setRan] = useState(false)
  if(!isLoadingStorages && !ran) {
    setOptionz(storages)
    setRan(true)
  }
  

  function inFirstOnly(list1, list2) {
    return operation(list1, list2);
  }
  
  function operation(list1, list2, isUnion) {
    var result = [];
    
    for (var i = 0; i < list1?.length; i++) {
        var item1 = list1[i],
            found = false;
        for (var j = 0; j < list2.length && !found; j++) {
            found = item1._id === list2[j]._id
        }
        if (found === !!isUnion) {
            result.push(item1);
        }
    }
  
    setOptionz(result)
    return result;
  }
  
  const [check, setCheck] = useState(true)
  if(check) {
      let options = inFirstOnly(storages, selectedStorages)
      setOptionz(options)
      setCheck(false)
  }

  console.log("SELECTED STORAGES", selectedStorages)

  const handleClearForm = () => {
    values.title=""
    values.desc= ""
    values.img= ""
    setBrand("")
    console.log("st", selectedStorages)
    setSelectedStorages([])
    setFieldValue("storages", [])
    setColor("")
    values.price= ""
    values.quantity= ""
    setProductImgLink("")
    setShowBtn(false)
  }

      //constructing the boolean colors checked array
      const [groupsObj, setGroupsObj] = useState({})
  
      useEffect(() => {
        console.log("GROUP ERROR", groupsError)
        if(!isLoadingGroups) {
          console.log("GROUPS#####", groups)
          Object.keys(groups).forEach(ele => {
            let key = groups[ele].groupName
              groupsObj[key] = groups[ele]._id;
          });
        }
      }, [groups, isLoadingGroups])

      console.log("groups obj", groupsObj)

  const [addSmartphone] = useAddSmartphoneMutation()
  const [addGroup] = useAddGroupMutation()

  const onSubmit = async(values, actions) => {
    values.storages.map(storage => {
      if(groupsObj[brand.brandName + " " + model.modelName + " " + storage.amount + storage.type]?.length>0) {
          addSmartphone({title: brand.brandName + " " + model.modelName  + " " + color.colorName + " " + storage.amount + storage.type, desc: values.desc, groupId: groupsObj[brand.brandName + " " + model.modelName + " " + storage.amount + storage.type], storageId: storage._id, brandId: brand._id, modelId: model._id, colorId: color._id, price: values.price, quantity: values.quantity, img: productImgLink}, { 
            headers: {
              'Token': `Bearer ${user?.accessToken}`
            }
          })
          .then(res => {
            toast.success(`${brand.brandName + " " + model.modelName  + " " + color.colorName + " " + storage.amount + storage.type} successfully created`)
          })
          .catch((e) => {
            toast("Product already exists")
            console.log("e is", e)
          })
      } else {
        addGroup({groupName: brand.brandName + " " + model.modelName + " " + storage.amount + storage.type})
        .then(res => {
          addSmartphone({title: brand.brandName + " " + model.modelName  + " " + color.colorName + " " + storage.amount + storage.type, desc: values.desc, groupId: res.data._id, storageId: storage._id, modelId: model._id, brandId: brand._id, colorId: color._id, price: values.price, img: productImgLink}, { 
            headers: {
              'Token': `Bearer ${user?.accessToken}`
            }
          })
          .then(res => {
            toast.success(`${brand.brandName + " " + model.modelName + " " + color.colorName + " " + storage.amount + storage.type} successfully created`)
          })
          .catch((e) => {
            toast("Product already exists")
            console.log("e is", e)
          })
        })
        .catch(err => {
          console.log("error when creating new group")
        })
      }
    })
    navigate('/smartphones/1')
  }
 


  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      title: "",
      desc: "",
      img: "",
      brand: "",
      group: "",
      storages: [],
      color: "",
      price: 0,
      quantity: 0,
      model: "",
    },
    onSubmit,
  });

  const navigate = useNavigate()

  const onFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const theme = useTheme()

  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));
  const isLg= useMediaQuery(theme.breakpoints.down('lg'));
  const isXl= useMediaQuery(theme.breakpoints.down('xl'));

  const [singleProduct, setSingleProduct] = useState(true)


  const renderMobileCreateProduct = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""} style={{width:'100%', height:'100%'}}>
      <form onSubmit={handleSubmit} action="/upload" encType="multipart/form-data" autoComplete="off" id="registerForm">
        <h3 className="center">Add New Smartphone</h3>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <Button size="small" variant="contained" style={{width: '150px', marginBottom: '15px'}} onClick={() => setSingleProduct(!singleProduct)}>{singleProduct ?  "Switch to multiple" : "Switch to single"}</Button>
        </div>

        <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
          <TextField
            id="desc"
            type="text"
            margin="dense"
            value={values.desc}
            onChange={handleChange}
            onBlur={handleBlur}
            label="desc"
            size="small"
            multiline
            rows={5}
          />
        </FormControl>

        {errors.desc && touched.desc && (
          <p className="error">{errors.desc}</p>
        )}

        <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand}
                    label="Brand"
                    onChange={handleBrand}
                    name="brand"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
       </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="model">Model</InputLabel>
                  <Select
                    id="model"
                    value={model}
                    label="Model"
                    onChange={handleModel}
                    name="model"
                  >
                      {models?.map((option) => (
                      <MenuItem key={option._id} value={option}>
                        {option.modelName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'}}>
        {productImgLink &&  <Image cloudName="deqqgmfxk"  publicId={productImgLink} style={{width: '200px', height: '200px', objectFit:'cover', objectPosition:'center'}}/>
        }
      </div>
        <Stack direction="row" justifyContent="space-between" sx={{marginBottom: '10px'}}>
          <Button  sx={{width: '150px'}} variant="contained" color="secondary" size="small" component="label">
            Upload
            <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
          </Button>
          <Button variant="contained" size="small" sx={{width: '150px'}} onClick={() => uploadImage()}>Save to cloud</Button>
        </Stack>


  <FormControl fullWidth style={{marginBottom: '10px'}} >
      <Autocomplete
        multiple
        id="tags-standard"
        freeSolo
        options={optionz}
        getOptionLabel={(option) => (option.amount + option.type)}
        defaultValue={[]}
        name="storages"
        onChange={(e, value) => {
          setCheck(true)
          if(singleProduct && (value.length === 1)) {
            setSelectedStorages(value)
          } else if(singleProduct && (value.length === 2)) {
            value.pop()
            toast("Switch to multiple in order to create more smartphones with different storages")
          } else if(!singleProduct) {
            setSelectedStorages(value)
          }
     
          inFirstOnly(storages, value)
          setFieldValue("storages", value);
        }}
        style={{marginBottom: '10px'}}
        renderInput={(params) => (
          <TextField
            {...params}
            margin="dense"
            variant="standard"
            label="Storages options"
            placeholder="Storages"
            value={values.storages}
          />
        )}
      />
      </FormControl>

        <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                    <InputLabel id="color">Color</InputLabel>
                    <Select
                      id="color"
                      value={color}
                      label="Color"
                      onChange={handleColor}
                      name="color"
                    >
                        {colors?.map((option) => (
                        <MenuItem key={option._id} value={option}>
                          {option.colorName}
                        </MenuItem>
                      ))}
                    </Select>
        </FormControl>
        
        {singleProduct && 
        <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
          <TextField
              id="price"
              type="number"
              margin="dense"
              value={values.price}
              onChange={handleChange}
              onBlur={handleBlur}
              label="price"
              size="small"
            />
        </FormControl>}
        {errors.price && touched.price && (
          <p className="error">{errors.price}</p>
        )}

      {singleProduct && 
        <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
          <TextField
              id="price"
              type="number"
              margin="dense"
              value={values.quantity}
              onChange={handleChange}
              onBlur={handleBlur}
              label="quantity"
              size="small"
            />
        </FormControl>}
        {errors.quantity && touched.quantity && (
          <p className="error">{errors.quantity}</p>
        )}
        

        <div className="btnContainer">
          <Stack direction="row" spacing={2}>
            {showBtn ?
                (<Button variant="contained" size="small" color="primary" id="submitBtn" type="submit">
                Create
              </Button>) : <Typography variant="subtitle2">Please upload an image in order to submit</Typography>
            } 
            <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/smartphones/1")}>
            Shop
            </Button>
          </Stack>
        </div>
      </form>
    </div>
  )

  const renderDesktopCreateProduct = () => (
    <div style={{display:'flex', justifyContent:'center', minHeight:'75vh'}}>
    <form onSubmit={handleSubmit} action="/upload" encType="multipart/form-data" autoComplete="off" id="registerForm">
      <Typography style={{marginTop:'64px'}} variant="h5" className="center">Add New Smartphone</Typography>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', margin:'15px 0'}}>
        <Button size="medium" variant="contained" style={{width:'175px'}} onClick={() => setSingleProduct(!singleProduct)}>{singleProduct ?  "Switch to multiple" : "Switch to single"}</Button>
      </div>

      <FormControl fullWidth style={{marginBottom: '10px'}} >
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand}
                    label="Brand"
                    onChange={handleBrand}
                    name="brand"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
       </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="model">Model</InputLabel>
                  <Select
                    id="model"
                    value={model}
                    label="Model"
                    onChange={handleModel}
                    name="model"
                  >
                      {models?.map((option) => (
                      <MenuItem key={option._id} value={option}>
                        {option.modelName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}} >
        <TextField
          id="desc"
          type="text"
          margin="dense"
          value={values.desc}
          onChange={handleChange}
          onBlur={handleBlur}
          label="desc"
          multiline
          rows={5}
        />
      </FormControl>

      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}

    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'}}>
      {productImgLink &&  <Image cloudName="deqqgmfxk"  publicId={productImgLink} style={{width: '200px', height: '200px', objectFit:'cover', objectPosition:'center'}}/>
      }
    </div>
      <Stack direction="row" justifyContent="space-between" style={{marginBottom:'15px'}}>
        <Button size="medium" sx={{width: '150px'}} variant="contained" color="secondary"  component="label">
          Upload
          <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
        </Button>
        <Button size="medium" variant="contained"  sx={{width: '150px'}} onClick={() => uploadImage()}>Save to cloud</Button>
      </Stack>

    <FormControl fullWidth style={{marginBottom: '10px'}} >
      <Autocomplete
        multiple
        id="tags-standard"
        freeSolo
        options={optionz}
        getOptionLabel={(option) => (option.amount + option.type)}
        defaultValue={[]}
        name="storages"
        onChange={(e, value) => {
          setCheck(true)
          if(singleProduct && (value.length === 1)) {
            setSelectedStorages(value)
          } else if(singleProduct && (value.length === 2)) {
            value.pop()
            toast("Switch to multiple in order to create more smartphones with different storages")
          } else if(!singleProduct) {
            setSelectedStorages(value)
          }
     
          inFirstOnly(storages, value)
          setFieldValue("storages", value);
        }}
        style={{marginBottom: '10px'}}
        renderInput={(params) => (
          <TextField
            {...params}
            margin="dense"
            variant="standard"
            label="Storages options"
            placeholder="Storages"
            value={values.storages}
          />
        )}
      />
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}} >
                  <InputLabel id="color">Color</InputLabel>
                  <Select
                    id="color"
                    value={color}
                    label="Color"
                    onChange={handleColor}
                    name="color"
                  >
                      {colors?.map((option) => (
                      <MenuItem key={option._id} value={option}>
                        {option.colorName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      
      {singleProduct && 
      <FormControl fullWidth style={{marginBottom: '10px'}} >
        <TextField
            id="price"
            type="number"
            margin="dense"
            value={values.price}
            onChange={handleChange}
            onBlur={handleBlur}
            label="price"
            
          />
      </FormControl>}
      {errors.price && touched.price && (
        <p className="error">{errors.price}</p>
      )}

    {singleProduct && 
      <FormControl fullWidth style={{marginBottom: '10px'}} >
        <TextField
            id="quantity"
            type="number"
            margin="dense"
            value={values.quantity}
            onChange={handleChange}
            onBlur={handleBlur}
            label="quantity"
            
          />
      </FormControl>}
      {errors.quantity && touched.quantity && (
        <p className="error">{errors.quantity}</p>
      )}
      

      <div>
        <Stack direction="row" spacing={2} style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
          {showBtn ?
              (<Button variant="contained"  color="primary" id="submitBtn" type="submit">
              Create
            </Button>) : <Typography variant="subtitle2">Please upload an image in order to submit</Typography>
          } 
          <Button variant="contained" startIcon={<ClearIcon />}  color="secondary" id="submitBtn" type="submit" onClick={() => handleClearForm()}>
          Clear
          </Button>
        </Stack>
      </div>
    </form>
  </div>
  )

  return (
    <div>
        {
        (isXs) ?  renderMobileCreateProduct() : 
        (isSm) ? renderMobileCreateProduct() :
        (isMd) ? renderMobileCreateProduct() :
        renderDesktopCreateProduct()
      }
    </div>
  );
}

export default CreateProduct